export interface DropdownOption {
  value: string;
  label: string;
}

export const MODEL_OPTIONS: DropdownOption[] = [
  { value: "GPT 4-o", label: "GPT 4-o" },
  { value: "GPT 4.1", label: "GPT 4.1" },
  {
    value: "Azure AI Search + Doc AI + GPT 4.1",
    label: "Azure AI Search + Doc AI + GPT 4.1"
  }
];

export const VALIDATION_RULE_OPTIONS: DropdownOption[] = [
  { value: "required", label: "Required" },
  { value: "optional", label: "Optional" },
  { value: "email", label: "Email Format" },
  { value: "numeric", label: "Numeric Only" },
  { value: "date", label: "Date Format" }
];
